import React from "react"
import { renderToString } from 'react-dom/server'
import { DEFAULT_VARIANT_COLOR, DEFAULT_COVERLETTER_TEMPLATE_COLOR } from "../constants/constants"
import { convert2rgba } from "../helper"
const PDF_STYLE = {
    default: {
        header: {
            width: "100%",
            WebkitPrintColorAdjust: "exact",
            height: "35px",
            position: "absolute",
            top: "0px",
            left: "0px",
            right: "0px",
            backgroundColor: "#FFFFF",
            //z index will keep the footer on top of long footer also
            zIndex: 1000
        },
        footer: {
            width: "100%",
            WebkitPrintColorAdjust: "exact",
            // height: "35px",
            //This height will cover the whole resume, it will create illusion of fulll color for half filled resumes also
            height: "850px",
            position: "absolute",
            left: "0px",
            right: "0px",
            // backgroundColor: "#FFFFF",
            // backgroundColor: "#E1B2F9",
            bottom: "0",
            // bottom: "500px",
        },
        leftsidebar: {
            width: "202px",
            //  backgroundColor: "#f2f4f4",
            //backgroundColor: "#D9F7D1",
            // height: "31px"
            height: "850px"
        }

    }
}

const resumeTemplatesMaping = {
    'template-one': { h1: 'default', h: 'default', f: 'default' },
    'template-one-v2': { h1: 'default', h: 'default', f: 'default' },
    'template-one-v3': { h1: 'default', h: 'default', f: 'default' },
    'template-two': { h1: 'default', h: 'default', f: 'default' },
    'template-two-v2': {
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#17a9e4' },
        bg_override_section: ['header']
    },
    'template-two-v3': {
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#17a9e4' },
        bg_override_section: ['header']
    },
    'template-three': {
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#b2436f' },
        bg_override_section: ['header']
    },
    'template-three-v2': { h1: 'default', h: 'default', f: 'default' },
    'template-three-v3': {
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#b2436f' },
        bg_override_section: ['header']
    },
    'template-three-v4': {
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#b2436f' },
        bg_override_section: ['header']
    },
    'template-three-v5': { h1: 'default', h: 'default', f: 'default' },
    'template-four': {
        h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#F2F4F4', width: '271px' }
    },
    'template-four-v2': {
        h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#F2F4F4', width: "272px" }
    },
    'template-four-v3': {
        h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#F2F4F4', width: "268px" }
    },
    'template-four-v4': {
        h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#F2F4F4', width: "268px" }
    },
    'template-four-v5': {
        h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#F2F4F4',width: "268px", },
        leftsidebarpage1style: { backgroundColor: '#58585b', width: "268px", height: "35px" },
        bg_override_section: ['page1leftsidebar'],
        //Testing header
        //  headerstyle: { backgroundColor: '#D9F7D1',height: "400px", } 
    },
    'template-five': { h1: 'default', h: 'default', f: 'default' },
    'template-five-v2': { h1: 'default', h: 'default', f: 'default' },
    'template-five-v3': { h1: 'default', h: 'default', f: 'default' },
    'template-five-v4': { h1: 'default', h: 'default', f: 'default' },
    'template-five-v5': { h1: 'default', h: 'default', f: 'default' },

    'template-six': {
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#5b509b' },
        bg_override_section: ['header']
    },
    'template-six-v2': { h1: 'default', h: 'default', f: 'default' },
    'template-six-v3': { h1: 'default', h: 'default', f: 'default' },

    'template-seven': {
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#F9F4E9' }
    },
    'template-seven-v2': { h1: 'default', h: 'default', f: 'default' },
    'template-seven-v3': { h1: 'default', h: 'default', f: 'default' },

    'template-eight': {
        h1: 'default', h: 'leftsidebar', f: 'leftsidebar',
        headerpage1style: { backgroundColor: '#5e8e66' },
        leftsidebarstyle: { backgroundColor: '#F2F4F4', width: '270px' },
        bg_override_section: ['header']
    },
    'template-eight-v2': {
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#F2F4F4' }
    },
    'template-eight-v3': {
        h1: 'default', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#5e8e66', width: '270px'},
        headerpage1style: { width: '595px', height: '400px', backgroundColor:'#FFFFFF' }, 
        // footerstyle: { width: '595px' },
        bg_override_section: ['leftsidebar']
    },

    'template-nine': {
        h1: 'default', h: 'leftsidebar', f: 'default',
        headerpage1style: { backgroundColor: '#0d183a' },
        leftsidebarstyle: {width: "272px", borderLeft: "solid 1px #000", height: '35px', left: 'auto', float: 'right'},
        footerstyle: {width: "272px", borderLeft: "solid 1px #000", height: '1200px', left: 'auto', float: 'right'},
        bg_override_section: ['header']
    },
    'template-nine-v2': {
        h1: 'default', h: 'leftsidebar', f: 'default',
        headerpage1style: { backgroundColor: '#F2F4F4' },
        leftsidebarstyle: {width: "272px", borderLeft: "solid 1px #000", height: '35px', left: 'auto', float: 'right'},
        footerstyle: {width: "272px", borderLeft: "solid 1px #000", height: '1200px', left: 'auto', float: 'right'},
        bg_override_section: ['header']
    },
    'template-nine-v3': {
        h1: 'default', h: 'leftsidebar', f: 'default', 
        headerpage1style: { backgroundColor: '#FFF' },
        footerstyle: { width: '270px', backgroundColor: '#0d183a', float: 'right', left: 'auto' }, 
        leftsidebarstyle: { backgroundColor: '#0d183a', float: 'right', width: '270px', heigh: '35px' },
        bg_override_section: ['footer', 'leftsidebar']
    },
    'template-ten': { 
        h1: 'default', h: 'default', f: 'default',
        
    },
    'template-ten-v2': { h1: 'default', h: 'default', f: 'default' },
    'template-ten-v3': { h1: 'default', h: 'default', f: 'default' },
    'template-ten-v4': { h1: 'default', h: 'default', f: 'default' },
    'template-ten-v5': { h1: 'default', h: 'default', f: 'default' },

    'template-eleven': { 
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#98C64D' },
        bg_override_section: ['header'],
    },
    'template-twelve': { 
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#2a64ad' },
        bg_override_section: ['header'],
     },
    'template-thirteen': { h1: 'default', h: 'default', f: 'default' },
    'template-fourteen': { 
        h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#5b509b'},
        bg_override_section: ['header']
    },
    'template-fifteen': { h1: 'default', h: 'default', f: 'default' },
    'template-sixteen': { h1: 'default', h: 'leftsidebar', f: 'leftsidebar',
        headerpage1style: { backgroundColor: '#98c64d', width: "268px"},
        leftsidebarstyle: { backgroundColor: '#98c64d',width: "268px", zIndex:1009 },
        bg_override_section: ['leftsidebar', 'header']
    },
    'template-seventeen': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        headerpage1style: { backgroundColor: '#2A64AD', width: "108px",},
        leftsidebarstyle: { backgroundColor: '#2A64AD',width: "108px",height: '1200px',top: '0', bottom: '0', position: 'absolute'},
        bg_override_section: ['leftsidebar', 'page1leftsidebar']
    },
    'template-eighteen': { h1: 'default', h: 'leftsidebar', f: 'default',
        headerpage1style: { backgroundColor: '#E9932F', height: '35px' } ,
        leftsidebarstyle: { backgroundColor: '#F5F5F5',width: "274px", left: 'auto', right: '0px', zIndex: '2001', height: '35px', float: 'right'},
        footerstyle: { width: '274px', left: 'auto', float:'right', zIndex:'1001', backgroundColor:'#F5F5F5' },
        bg_override_section: ['header']
    },
    'template-nineteen': { h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: '#DD3B7A' } ,
        bg_override_section: ['header']
    },
    'template-twenty': { h1: 'default', h: 'default', f: 'default' },
    'template-twenty-one': { h1: 'default', h: 'leftsidebar', f: 'leftsidebar' ,
            headerpage1style: { backgroundColor: '#FFE352', height: '920px', width: '594px', position: 'absolute', top: '-35px'  } ,
            leftsidebarstyle: { backgroundColor: '#FFE352', marginLeft: '213px', width: '594px' },
            footerstyle: { width: '212.4px', backgroundColor:'#2A2C27', top: '-35px', position: 'absolute', height: '920px', borderRight: 'solid 1px #2A2C27', zIndex: '1001' },
            bg_override_section: ['leftsidebar', 'header']
    },
    'template-twenty-three': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        headerpage1style: { backgroundColor: '#B8F19D', height: '34px', position: 'absolute', zIndex: '1006' } ,
        leftsidebarstyle: { backgroundColor: '#385718', float: 'right', width: '274px', height: '1200px', left: 'auto', right: '0' },
        leftsidebarpage1style: { backgroundColor: '#385718', float: 'right', width: '274px', left: 'auto', height: '1200px' },
        footerstyle: { width: '274px', height: '1200px', left:'auto', right: '0', bottom: '0', float: 'right', zIndex:'1002' },
        bg_override_section: ['leftsidebar', 'page1leftsidebar'],
        bg_faded_override_section: ['header']
    },
    'template-twenty-four': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { backgroundColor: '#EAE7FF', left:'auto', float: 'right', position: 'absolute', height: '1200px', zIndex: '1002', width: '274px', right: '0' },
        leftsidebarpage1style: { backgroundColor: '#EAE7FF', left:'auto', float: 'right', position: 'absolute', height: '1200px', zIndex: '1002', width: '274px', right: '0' },
        footerstyle: {backgroundColor: '#F5F5F5', width: '100%', left: '0', right: '0', height: '1200px', zIndex: 999},
        bg_faded_override_section: ['leftsidebar', 'page1leftsidebar']
     },
    'template-twenty-five': {
        h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#f5f1ee', width: '271px' },
    },

    'template-thirty-one': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#144F5D', float: 'left', width: '294px', height: '1200px', left: 'auto', right: '0' },
        leftsidebarpage1style: { backgroundColor: '#144F5D', float: 'left', width: '294px', right: 'auto', height: '1200px' },
        footerstyle: { width: '297px', height: '1200px', left:'0', right: 'auto', bottom: '0', float: 'left', zIndex:'1002' },
        bg_override_section: ['leftsidebar', 'page1leftsidebar'],
    },

    'template-thirty-two': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        footerstyle: { backgroundColor: 'rgba(217, 217, 217, 1)', width: '291px', height: '1200px', left:'0', top: '0', float: 'left', zIndex:'1002' },
    },

    'template-thirty-three': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#8D7CC2', float: 'left', width: '271px', height: '1200px', left: 'auto', right: '0' },
        // leftsidebarpage1style: { backgroundColor: '#DAD2E9', float: 'left', width: '271px', right: 'auto', height: '600px' },
        // footerstyle: { width: '271px', height: '1200px', left:'0', right: 'auto', bottom: '0', float: 'left', zIndex:'1002' },
        bg_override_section: ['leftsidebar', 'page1leftsidebar'],
    },

    'template-thirty-four': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#144F5D', float: 'left', width: '290px', height: '1200px', left: 'auto', right: '0' },
        footerstyle: { width: '290px', height: '1200px', left:'0', right: 'auto', bottom: '0', float: 'left', zIndex:'1002' },
        bg_override_section: ['leftsidebar', 'page1leftsidebar'],
    },

    'template-thirty-five': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { borderRight: "solid 1px #1F1F1F3C", backgroundColor: '#FCF6F6', left:'auto', float: 'left', position: 'absolute', height: '1200px', zIndex: '1002', width: '257px', left: '0' },
        leftsidebarpage1style: {borderRight: "solid 1px #1F1F1F3C", backgroundColor: '#FCF6F6', left:'auto', float: 'left', position: 'absolute', left: '0px', top: 40, height: '1200px', zIndex: '1002', width: '257px' },
        footerstyle: {background: '#FCF6F6', width: '100%', left: '0', right: '0', height: '1200px', zIndex: 999},
        // bg_faded_override_section: ['leftsidebar', 'page1leftsidebar', 'footerstyle']
    },

    'template-thirty-six': { 
        h1: 'default', h: 'leftsidebar', f: 'leftsidebar',
        headerpage1style: { backgroundColor: '#434343', height: '34px'},
        leftsidebarstyle: { backgroundColor: '#D9D9D9', width: '271px', height: '1200px', top: '0' },
        footerstyle: {backgroundColor: '#D9D9D9', width: '271px', top:0 },
        bg_override_section: ['header', 'page1leftsidebar'],
     },

    'template-thirty-seven': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        footerstyle: {backgroundColor: '#F5F5F5', width: '273px', height: '1200px', left:'0', position: 'absolute', top: '0', zIndex:'1002' },
    },

    'template-thirty-eight': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        footerstyle: { backgroundColor: '#F5F5F5', width: "calc(100% - 260px)", height: '1200px', position:'absolute', left: 'auto', right: '0', top: "0"} ,
    },

    'template-thirty-nine': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarpage1style: { backgroundColor: '#0C5395', width: '240px', marginLeft:'8px', position: 'absolute', top: '0', zIndex: '1002' } ,
        leftsidebarstyle: { marginLeft:'8px', backgroundColor: '#434343', width: '240px' },
        bg_override_section: ['page1leftsidebar', 'leftsidebar'],
    },

    'template-forty': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { marginLeft: '392px', backgroundColor: '#F3F3F3', width: "100%"},
        footerstyle: { marginLeft: '392px', backgroundColor: '#F3F3F3', width: "100%"},
    },

    'template-forty-one': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#0C5395', width: '295px', height: '1200px', left:'0', top: '0', zIndex:'1002' },
        footerstyle: {width: '100%', backgroundColor: '#f5f5f5', height: 1200, position: 'absolute', bottom: '0', zIndex:'1002'},
        bg_override_section: ['leftsidebar'],
    },

    'template-forty-two': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: {float: 'left', width: '286px', backgroundColor: '#434343', height: 1200, position: 'absolute', bottom: '0', zIndex:'1002'},
        footerstyle: {float: 'left', width: '286px', backgroundColor: '#434343', height: 1200, position: 'absolute', bottom: '0', zIndex:'1002'},
    },

    'template-forty-three': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { backgroundColor: '#144F5D',  height: '1200px',  width: '100%', },
        leftsidebarpage1style: { backgroundColor: '#144F5D',  height: '1200px',  width: '100%', },
        footerstyle: {backgroundColor: '#ECE9E9', width: '282px', left: '0', right: '0', height: '1200px', zIndex: '1002'},
        bg_override_section: ['leftsidebar', 'page1leftsidebar']
     },

    'template-forty-four': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#434343',  height: '1200px',  width: '294px', position: 'absolute', top: '0', zIndex: "1002" },
        footerstyle: {backgroundColor: '#F5F5F5', width: '100%', left: '0', right: '0', height: '1200px', zIndex: '999'},   
        bg_override_section: ['leftsidebar', 'page1leftsidebar']
     },

    'template-forty-five': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { backgroundColor: '#DAD2E9', position: 'absolute', height: '1200px', zIndex: '1002', width: '273px', left: '0' },
        leftsidebarpage1style: { backgroundColor: '#DAD2E9', position: 'absolute', height: '1200px', zIndex: '1002', width: '273px', left: '0' },
        footerstyle: {backgroundColor: '#ffffff', width: '100%', left: '0', zIndex: 999},
        bg_faded_override_section: ['leftsidebar', 'page1leftsidebar']
    },

    'template-forty-six': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        h1: 'default', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarstyle: { backgroundColor: '#F2F4F4', width: '100%', marginLeft: "440px" },
    },

    'template-forty-seven': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { backgroundColor: '#434343',  height: '1200px',  width: '248px', position: 'absolute', top: '0', zIndex: "1002" },
        leftsidebarpage1style: { backgroundColor: '#434343',  height: '1200px',  width: '248px', position: 'absolute', top: '0', zIndex: "1002" },
        footerstyle: {backgroundColor: '#F5F5F5', width: '100%', left: '0', right: '0', height: '1200px', zIndex: '999'},   
        bg_override_section: ['leftsidebar', 'page1leftsidebar']
     },

    'template-forty-eight': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        footerstyle: {backgroundColor: '#144F5D', width: '257px', left: '0', right: '0', height: '1200px', zIndex: '1002'},
    },

    'template-forty-nine': { h1: 'leftsidebar', h: 'leftsidebar', f: 'leftsidebar',
        leftsidebarpage1style: { backgroundColor: '#434343', width: '270px'},
        leftsidebarstyle: { backgroundColor: '#434343', width: '270px'},
        bg_override_section: ['page1leftsidebar', 'leftsidebar'],
    },

    'template-fifty': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { transform:'scaleX(1.004)', backgroundColor: '#0C5395',  height: '1200px',  width: '294px', position: 'absolute', top: '0', zIndex: "1002" },
        leftsidebarpage1style: {transform:'scaleX(1.004)', backgroundColor: '#0C5395',  height: '1200px',  width: '294px', position: 'absolute', top: '0', zIndex: "1002" },
        footerstyle: {backgroundColor: '#F5F5F5', width: '100%', left: '0', right: '0', height: '1200px', zIndex: '999'},
        bg_override_section: ['leftsidebar', 'page1leftsidebar']
    },
}

const coverletterTemplatesMaping = {
    'template-twenty-four': { h1: 'default', h: 'default', f: 'default',
        // bg has to be hard coded
        footerstyle: { width: '100%', left: '0', float:'0', top: '0', bottom: '0', zIndex:'1001', backgroundColor:'#f5f5f5', height: '1200px' }
    },
    'template-eleven': { h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-eleven'] },
        bg_override_section: ['header'],
    },
    'template-twelve': { h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: "#4D5279" },
        bg_override_section: ['header'],
     },
    'template-thirteen': { h1: 'default', h: 'default', f: 'default' },
    'template-fourteen': { h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-fourteen'] },
        bg_override_section: ['header'],
    },
    'template-sixteen': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-sixteen'], width: "218px", height: '1200px', top: '0', bottom: '0', position: 'absolute' },
        bg_override_section: ['leftsidebar','page1leftsidebar'],
     },
    
    'template-seventeen': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-seventeen'], width: "43px", height: '1200px', top: '0', bottom: '0', position: 'absolute' },
        bg_override_section: ['leftsidebar', 'page1leftsidebar'],
    },
    'template-eighteen': { h1: 'default', h: 'leftsidebar', f: 'leftsidebar',
        headerpage1style: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-eighteen'] },
        leftsidebarstyle: { backgroundColor: '#F5F5F5', width: "169px", height: '1200px', top: '0', bottom: '0', position: 'absolute' },
        bg_override_section: ['header'],
    },
    'template-nineteen': { h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-nineteen'] },
        bg_override_section: ['header'],
    },
    'template-twenty-three': { h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-twenty-three'] },
        bg_override_section: ['header'],
    },
    'template-sixteen-v2': { h1: 'leftsidebar', h: 'leftsidebar', f: 'default',
        leftsidebarstyle: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-sixteen-v2'], width: "223px", height: '1400px', left: '0', top: '0', bottom: '0', position: 'absolute' },
        footerstyle: { width: '100%', left: '0', float:'0', top: '0', bottom: '0',backgroundColor:'#FFF4CF', height: '1200px' },
        bg_override_section: ['leftsidebar', 'page1leftsidebar'],
     },
     'template-twenty-three-v2': { h1: 'default', h: 'default', f: 'default',
        headerpage1style: { backgroundColor: DEFAULT_COVERLETTER_TEMPLATE_COLOR['template-twenty-three-v2']},
        bg_override_section: ['header'],
     },
     
    
}

const colorVariant = {
  'color-variant-green': '#98c64d',
  'color-variant-blue': '#17a9e4',
  'color-variant-purple': '#5B509B',
  'color-variant-orange': '#de8535',
  'color-variant-green-two': '#5e8e66',
  'color-dark-grey-variant': '#58585b',
  'color-variant-pink': '#b2436f',
  'color-variant-pink-two': '#dd3b7a',
  'color-navy-blue-variant': '#0d183a',
  'color-variant-twenty-five': '#a71b24',
};
export const PDFHeaderFooter = (template, active_color, custom_template_color, entitytype) => {
    const resumeTpl = entitytype =='coverletter' ? coverletterTemplatesMaping[template] : resumeTemplatesMaping[template] ;
    // let rgbaColor = convert2rgba(custom_template_color, 0.5);
    const defaultColor = entitytype =='coverletter' ? coverletterTemplatesMaping[template] : resumeTemplatesMaping[template] ;
    const style = {}
    const override = custom_template_color ? {
        backgroundColor: custom_template_color
    } : {}
    const customoverride = {
        backgroundColor: custom_template_color ? convert2rgba(custom_template_color, 0.5) : DEFAULT_VARIANT_COLOR[active_color]
    }
    let h1, h, f;
    const headerstyle = resumeTpl.hasOwnProperty('headerstyle') ? resumeTpl.headerstyle : {}
    const leftsidebarstyle = resumeTpl.hasOwnProperty('leftsidebarstyle') ? resumeTpl.leftsidebarstyle : {}
    const headerpage1style = resumeTpl.hasOwnProperty('headerpage1style') ? resumeTpl.headerpage1style : headerstyle
    const leftsidebarpage1style = resumeTpl.hasOwnProperty('leftsidebarpage1style') ? resumeTpl.leftsidebarpage1style : leftsidebarstyle
    const footerstyle = resumeTpl.hasOwnProperty('footerstyle') ? resumeTpl.footerstyle : {}
    //First page header styling
    if (resumeTpl.h1 == 'default') {
           const style = (resumeTpl?.bg_override_section && resumeTpl?.bg_override_section.indexOf('header') > -1) ? override : {}
           h1 = defaultHeaderTpl({ ...headerpage1style, ...style })
       } else if (resumeTpl.h1 == 'leftsidebar') {
           let style = {};
           if(!custom_template_color?.length) style = {}
           else if(resumeTpl?.bg_override_section?.indexOf('header') > -1) style = override
           else if(resumeTpl?.bg_faded_override_section?.indexOf('header') > -1) style = customoverride
           let style1 = {}
           if(!custom_template_color?.length) style1 = {}
           else if(resumeTpl?.bg_override_section?.indexOf('page1leftsidebar') > -1) style1 = override
           else if(resumeTpl?.bg_faded_override_section?.indexOf('page1leftsidebar') > -1) style1 = customoverride
           h1 = leftsidebarHeaderTpl({ ...headerpage1style, ...style }, { ...leftsidebarpage1style, ...style1 })
       }   
    // else
    //     h1 = defaultHeaderTpl(style)

    //Other than First page header styling
    if (resumeTpl.h == 'default') {
        let style = {}
        h = defaultHeaderTpl({ ...headerstyle, ...style })
    } else if (resumeTpl.h == 'leftsidebar') {
        let style = {}
        let style1 = {}
        if(!custom_template_color?.length) style1 = {}
        else if(resumeTpl?.bg_override_section?.indexOf('leftsidebar') > -1) style1 = override
        let bgfadedstyle1 = {}
        if(!custom_template_color?.length) bgfadedstyle1 = {}
        else if(resumeTpl?.bg_faded_override_section?.indexOf('leftsidebar') > -1) bgfadedstyle1 = customoverride
        h = leftsidebarHeaderTpl({ ...headerstyle, ...style }, { ...leftsidebarstyle, ...style1, ...bgfadedstyle1 })
    }
    // else
    //     h = defaultHeaderTpl(style)

    //ALl pages footer styling
    if (resumeTpl.f == 'default') {
        const style = {}
        f = defaultFooterTpl({ ...footerstyle, ...style })
    } else if (resumeTpl.f == 'leftsidebar') {
        const style = {}
        const style1 = (resumeTpl?.bg_override_section && resumeTpl?.bg_override_section.indexOf('leftsidebar') > -1) ? override : {}
        const bgfadedstyle1 = (resumeTpl?.bg_faded_override_section && resumeTpl?.bg_faded_override_section.indexOf('leftsidebar') > -1) ? customoverride : {}
        f = leftsidebarFooterTpl({ ...footerstyle, ...style }, { ...leftsidebarstyle, ...style1, ...bgfadedstyle1 })
    }
    // else
    //     f = defaultFooterTpl(style)

    return { h1: h1, h: h, f: f }
}

const defaultHeaderTpl = (headerStyle) => {
    const fs = ({ ...PDF_STYLE.default.header, ...headerStyle })
    return renderToString(<div style={fs}> </div>)
}
const defaultFooterTpl = (style) => renderToString(<div style={{ ...PDF_STYLE.default.footer, ...style }}> </div>)
const leftsidebarHeaderTpl = (headerStyle, colStyle) => renderToString(<div style={{ ...PDF_STYLE.default.header, ...headerStyle }}><div style={{ ...PDF_STYLE.default.leftsidebar, ...colStyle }}></div></div>)
const leftsidebarFooterTpl = (footerStyle, colStyle) => renderToString(<div style={{ ...PDF_STYLE.default.footer, ...footerStyle }}><div style={{ ...PDF_STYLE.default.leftsidebar, ...colStyle }}></div></div>)